import { render, staticRenderFns } from "./CommentLayout.vue?vue&type=template&id=6b18bb6e&scoped=true&"
import script from "./CommentLayout.vue?vue&type=script&lang=js&"
export * from "./CommentLayout.vue?vue&type=script&lang=js&"
import style0 from "./CommentLayout.vue?vue&type=style&index=0&id=6b18bb6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18bb6e",
  null
  
)

export default component.exports